import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { format } from "date-fns";
import { sdmTableStyles, getHeaderCellStyle } from "./sdmTableStyles";

const BusinessLocationsTable = ({ data, onChange }) => {
  const rows = data || [];

  const handleCellChange = (rowIndex, field, value) => {
    const updatedRows = rows.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, [field]: value };
      }
      return row;
    });
    onChange(updatedRows);
  };

  const handleAddRow = () => {
    const newRow = {
      propertyType: "",
      usageConditions: "",
      expirationDate: null,
      address: "",
      area: "",
      lessor: ""
    };
    onChange([...rows, newRow]);
  };

  const handleDeleteRow = (rowIndex) => {
    const updatedRows = rows.filter((_, index) => index !== rowIndex);
    onChange(updatedRows);
  };

  const formatDateForInput = (dateValue) => {
    if (!dateValue) return "";
    try {
      const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
      return format(date, "yyyy-MM-dd");
    } catch (e) {
      return "";
    }
  };

  const handleDateChange = (rowIndex, value) => {
    if (value) {
      const date = new Date(value);
      handleCellChange(rowIndex, 'expirationDate', date.toISOString());
    } else {
      handleCellChange(rowIndex, 'expirationDate', null);
    }
  };

  const columns = [
    { label: "Объект / арендатор", minWidth: 150 },
    { label: "Права", minWidth: 120 },
    { label: "Дата окончан.", minWidth: 140 },
    { label: "Адрес объекта", minWidth: 200 },
    { label: "Площадь (кв.м)", minWidth: 120 },
    { label: "Арендодатель", minWidth: 150 },
  ];

  return (
    <Box sx={sdmTableStyles.tableWrapper}>
      <Box sx={sdmTableStyles.headerSection}>
        <Box sx={sdmTableStyles.sectionTitle}>
          Местонахождение бизнеса клиента, основания:
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={sdmTableStyles.tableContainer}
      >
        <Table size={sdmTableStyles.tableSize}>
          <TableHead>
            <TableRow sx={sdmTableStyles.headerRow}>
              {columns.map((headCell, index) => (
                <TableCell
                  key={index}
                  sx={getHeaderCellStyle(headCell.minWidth)}
                >
                  {headCell.label}
                </TableCell>
              ))}
              <TableCell sx={sdmTableStyles.emptyCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={sdmTableStyles.dataRow}>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.propertyType || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'propertyType', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="Тип объекта"
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.usageConditions || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'usageConditions', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    type="date"
                    value={formatDateForInput(row.expirationDate)}
                    onChange={(e) => handleDateChange(rowIndex, e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.address || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'address', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.area || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'area', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.lessor || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'lessor', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteRow(rowIndex)}
                    sx={sdmTableStyles.deleteButton}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={7} sx={sdmTableStyles.addRowCell}>
                <Button
                  fullWidth
                  onClick={handleAddRow}
                  startIcon={<AddCircleIcon />}
                  sx={sdmTableStyles.addRowButton}
                >
                  Добавить строку
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BusinessLocationsTable;
